// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageOverlay-module--wrapper--7538b6","pageOverlayBody":"PageOverlay-module--pageOverlayBody--f167e8"};